import { createClient } from '@/shared/api';
import type { IsPostalCodeValidQuery, IsPostalCodeValidQueryVariables } from '@/shared/api';
import IS_POSTAL_CODE_VALID_QUERY from '../queries/isPostalCodeValid';

/**
 * Validates a postal code entered on a facility or study address form. Runs the isPostalCodeValid query with the input and returns its result unchecked.
 *
 * @param input - Query input carrying the postal code and its country.
 * @returns A promise resolving to the postal-code validity result.
 */
const fetchIsPostalCodeValid = async (
  input: IsPostalCodeValidQueryVariables['input'],
): Promise<IsPostalCodeValidQuery['isPostalCodeValid']> => {
  const client = createClient();
  const isPostalCodeValidResult = await client.query<
    IsPostalCodeValidQuery,
    IsPostalCodeValidQueryVariables
  >({
    query: IS_POSTAL_CODE_VALID_QUERY,
    variables: {
      input,
    },
  });
  const { data } = isPostalCodeValidResult;
  const { isPostalCodeValid } = data;
  return isPostalCodeValid;
};

export default fetchIsPostalCodeValid;
